import { createContext, useContext, type ButtonHTMLAttributes, type HTMLAttributes, type ReactNode } from "react";

type TabsState = { value: string; onValueChange: (value: string) => void };
const TabsContext = createContext<TabsState | null>(null);

export function Tabs({ value, onValueChange, className = "", children }: { value: string; onValueChange: (value: string) => void; className?: string; children: ReactNode }) {
  return <TabsContext.Provider value={{ value, onValueChange }}><div className={className}>{children}</div></TabsContext.Provider>;
}

export function TabsList({ className = "", children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="tabs-list" className={className} {...props}>{children}</div>;
}

export function TabsTrigger({ value, className = "", children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { value: string }) {
  const tabs = useContext(TabsContext);
  if (!tabs) throw new Error("TabsTrigger debe estar dentro de Tabs");
  const active = tabs.value === value;
  return <button type="button" data-slot="tabs-trigger" data-state={active ? "active" : "inactive"} className={className} onClick={() => tabs.onValueChange(value)} {...props}>{children}</button>;
}

export function TabsContent({ value, className = "", children, ...props }: HTMLAttributes<HTMLDivElement> & { value: string }) {
  const tabs = useContext(TabsContext);
  if (!tabs) throw new Error("TabsContent debe estar dentro de Tabs");
  if (tabs.value !== value) return null;
  return <div data-slot="tabs-content" className={className} {...props}>{children}</div>;
}

export function Button({ variant = "default", className = "", type = "button", ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "default" | "outline" }) {
  return <button type={type} className={`ui-button ${variant === "outline" ? "outline" : ""} ${className}`.trim()} {...props} />;
}

export function Progress({ value = 0 }: { value?: number }) {
  const normalized = Math.max(0, Math.min(100, value));
  return <div data-slot="progress" className="progress-root" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={normalized}><span style={{ width: `${normalized}%` }} /></div>;
}
